<div class="field boolean">
    <mat-form-field>
        <mat-select [formControl]="control">
            <mat-option [value]="true">{{mapCurrentValue(true)}}</mat-option>
            <mat-option [value]="false">{{mapCurrentValue(false)}}</mat-option>
            <mat-option [value]="'any'">Ignore</mat-option>
        </mat-select>
    </mat-form-field>
</div>
